import Component from 'vue-class-component'
import Vue from 'vue'
import { IUser } from '../../model/user'
import userStore from '../../store/user/user-store'
import ReactButton from './ReactButton.vue'
import statementStore from '../../store/statement/statement-store'

@Component({
  name: 'ignoreButton',
  props: ['statement'],
  components: { 'react-button' : ReactButton }
})
export default class IgnoreButton extends Vue {

  protected ignoreStatement (): void {
    statementStore.dispatchIgnoreStatement(this.$props['statement'])
  }

  protected unignoreStatement (): void {
    statementStore.dispatchUnignoreStatement(this.$props['statement'])
  }

}
